<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-0 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content">
  <!--Call-Text-->
  <div class="i-main-call py-5 container">
    <div class="col text-center px-2 px-lg-5 pt-2 pb-4">
      MOVER AS PESSOAS<br />
      PARA O SEU MELHOR LUGAR
    </div>
  </div>
  <!--About-Content-->
  <div class="i-about container pb-5">
    <div class="i-section row pt-3 pb-5">
      <!--Aside-->
      <div class="i-aside col-12 col-lg-4 pb-5">
        <ul class="nav d-flex flex-column">
          <li *ngFor="let p of paginas" class="nav-item">
            <a class="i-text nav-link pl-0 pb-3" [routerLink]="baseURL">INSTITUCIONAL</a>
          </li>
          <ng-container *ngIf="paginas">
            <li *ngFor="let p of paginas" class="nav-item">
              <a class="i-text nav-link pl-0 pb-3" routerLinkActive="active" [routerLink]="baseURL + p.slug">{{
                p.menu | uppercase
              }}</a>
              <ul *ngIf="p.filhasAtivas?.length > 0" class="i-sub-item">
                <li *ngFor="let pf of p.filhasAtivas" class="nav-item pl-3">
                  <a class="i-text nav-link pl-0 pb-3" routerLinkActive="active" [routerLink]="baseURL + pf?.slug">{{
                    pf?.menu | uppercase
                  }}</a>
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>
      </div>
      <!--Main-Content-->
      <div class="i-content col-12 col-lg-8">
        <div *ngIf="pagina.titulo" class="i-title text-left pt-2 pb-5">{{ pagina.titulo }}</div>
        <div class="pb-5 i-text" [innerHTML]="pagina.conteudo | html"></div>
        <div *ngIf="pagina?.anexos?.length > 0" class="col-12 py-3">
          <b>Anexos</b>
          <ul class="i-attachments mt-2">
            <li *ngFor="let a of pagina.anexos" class="pb-2">
              <div [class]="'i-file i-file-' + a?.tipoCSS">
                <a [href]="a?.arquivoURL" target="_blank" [title]="a?.descricao">{{ a?.titulo }}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
